import { Component } from '@angular/core';

@Component({
    selector: 'app-host-location',
    imports: [],
    templateUrl: './host-location.component.html',
    styleUrl: './host-location.component.scss',
})
export class HostLocationComponent {}
